import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  DangerInformation,
  Exemption_6_5,
  Vessel
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";
import {sendQuery} from "../../../../../common/utils";

@Component({
    selector: 'app-visit-exemptions-exemption-6-5',
    templateUrl: './exemption_6_5.component.html',
    styleUrls: ['./exemption_6_5.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_6_5Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_6_5;

  portVisitUtils = PortvisitUtils;
  dangerousGoods?: DangerInformation;

  vessel: Vessel;

  searchVessel = term => sendQuery('com.portbase.bezoekschip.common.api.visit.FindVessels', {term: term});

  resetVesselInfo() {
    this.vessel = null;
    this.exemption.vesselENI = '';
    this.exemption.vesselIMO = '';
    this.exemption.vesselNameENI = '';
    this.exemption.vesselNameIMO = '';
  }
}
